import React, { Component } from 'react'
import { Menu } from 'semantic-ui-react'

export default class CategorySelector extends Component {
  render() {
    const { selectedCategory, categories, filterCategory } = this.props

    return (
      <Menu vertical fluid>
        <Menu.Item>
          <Menu.Header>Categories</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              active={selectedCategory === null}
              onClick={() => filterCategory(null)}
            >
              All <br />
              <small>&emsp;All categories</small>
            </Menu.Item>
            {categories.length > 0
              ? categories.map(cat =>
                  <Menu.Item
                    key={cat.id}
                    active={selectedCategory === cat.id}
                    onClick={() => filterCategory(cat.id)}
                  >
                    {cat.name} <br />
                    <small>&emsp;{cat.description}</small>
                  </Menu.Item>
                )
              : null}
          </Menu.Menu>
        </Menu.Item>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CategorySelector.jsx